import { useState, useEffect } from 'react';
import type { OrgSettings } from '@atlassian/integrations/third-party';
import { fetchOrgSettings } from '@atlassian/integrations/third-party';
import {
	controlSettingsLoaded,
	invitePeopleRendered,
	invitePeopleRenderedTimings,
} from '../../analytics/ufoExperiences';
import { useAnalytics } from '../../analytics';
import { ExperimentsAnalytics } from '../ExperimentsAnalytics';
import { resolveError } from '../../utils';

export const useOrgControlSettings = (orgId: string | null) => {
	const analytics = useAnalytics(ExperimentsAnalytics);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [settings, setData] = useState<OrgSettings>({});

	useEffect(() => {
		if (!orgId) {
			setIsLoading(false);
			return;
		}

		(async () => {
			controlSettingsLoaded.start();
			setIsLoading(true);
			try {
				invitePeopleRendered.mark(invitePeopleRenderedTimings.fetchOrgSettings.startMark);
				const settings = await fetchOrgSettings(orgId);
				invitePeopleRendered.mark(invitePeopleRenderedTimings.fetchOrgSettings.endMark);
				controlSettingsLoaded.success();
				setData(settings);
			} catch (error) {
				const { errorMessage, responseCode } = resolveError(error);
				analytics.fetchOrgSettingsFailed({
					orgId,
					errorMessage,
					responseCode,
				});

				controlSettingsLoaded.failure();
			} finally {
				setIsLoading(false);
			}
		})();
	}, [analytics, orgId]);

	return { isLoading, settings };
};
